import { render, staticRenderFns } from "./NegativeIcon.vue?vue&type=template&id=2184fd18&functional=true"
import script from "./NegativeIcon.vue?vue&type=script&lang=js"
export * from "./NegativeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports